var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('v-radio-group',{attrs:{"mandatory":""},model:{value:(_vm.planId),callback:function ($$v) {_vm.planId=$$v},expression:"planId"}},_vm._l((_vm.plans),function(p){return _c('v-radio',{key:p.id,attrs:{"label":p.name,"value":p.id,"color":"#f2ba36"}})}),1),_c('div',{attrs:{"id":"paypal-button-container"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }